import { useAuth } from "@/hooks/use-auth";
import { useAppStore } from "@/stores";

const SUGGEST_CHANGE_MODAL_ID = "suggest-change";
const SEEN_KEY = "speak.suggest-change.seen";

function readSeen(): boolean {
  try {
    return window.localStorage.getItem(SEEN_KEY) === "1";
  } catch {
    return true;
  }
}

function markSeen() {
  try {
    window.localStorage.setItem(SEEN_KEY, "1");
  } catch {
    // Blocked storage only means the "new" dot can show again.
  }
}

/** Whether the person is signed in (the only time a suggestion can be sent), whether the panel is open, and whether they have opened it before. */
export function useSuggestChange() {
  const { isLoggedIn } = useAuth();
  const isOpen = useAppStore((s) => s.activeModal === SUGGEST_CHANGE_MODAL_ID);
  const openModal = useAppStore((s) => s.openModal);
  const closeModal = useAppStore((s) => s.closeModal);
  return {
    enabled: isLoggedIn,
    isOpen,
    seen: isOpen || readSeen(),
    open: () => {
      markSeen();
      openModal(SUGGEST_CHANGE_MODAL_ID);
    },
    close: closeModal,
  };
}
